import triggerTracking from '@blueprint/tracking';

export const TRACKING_EVENT = 'GAEvent';
export const OPTIN_TRACKING_CATEGORY = 'permission opt-in';
export const REGISTRATION_TRACKING_CATEGORY = 'registration';

export const trackOptin = (consent: boolean, label: string | undefined) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: OPTIN_TRACKING_CATEGORY,
        eventAction: consent ? 'optin_both' : 'optin_neither',
        eventLabel: `${label || 'auth_modal'}_step_2`
    });
};

export const trackSubmit = (label: string | undefined) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: REGISTRATION_TRACKING_CATEGORY,
        eventAction: 'submit',
        eventLabel: `${label || 'auth_modal'}_step_2`
    });
};

export const trackAboutMe = (status: string | undefined) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: REGISTRATION_TRACKING_CATEGORY,
        eventAction: 'about_me',
        eventLabel: status?.toString() || 'blank'
    });
};
